import React from 'react';
import './Projects.css';
import ProjectExample from './ProjectExample';
import overlookImg from './overlook.png';
import hpImg from './hp.png';
import pokeImg from './pokedex.png';
import celestial from './celestial.png';
import styleStash from './stylestash.png';
import kanjiPanda from './kanjipanda.png';
import dm from './dm.png';
import aiproject from './projectplanner.png'

const Projects = () => {
  return (
    <div className='project-page'>
      <main className='project-main'>
        <h1>My Projects</h1>
        <h2>JavaScript, React, TypeScript</h2>
      </main>
      <ProjectExample
        title="Kanji Panda"
        tagline="A Japanese Learner's Companion for Studying Kanji"
        technologies={["TypeScript", "React", "Node.JS", "Express.JS", "MongoDB", "Google OAuth", "HTML/CSS"]}
        context="August 2023 - present | Solo Passion Project"
        img={kanjiPanda}
        summary="Unleash the power of kanji with this captivating study companion! Upon page load, users are greeted with 5 random characters. Dive into pronunciation and meanings at a tap, and save the ones you love to study. Plus, easily search by English meaning or character to fuel your language journey."
        alt="image of kanji panda project"
        deployLink="https://kanji-panda-ts.vercel.app/"
        ghLink="https://github.com/sakisandrac/kanji-panda-ts"
      />
      <ProjectExample
        title="AI Project Planner"
        tagline="AI project generator and planner for developers"
        technologies={["React", "TypeScript", "OpenAI", "Google OAuth", "Cypress"]}
        context="September 2023 | Group Project"
        img={aiproject}
        summary="An application designed to streamline the project planning process for developers by leveraging advanced AI technology to craft comprehensive project plans and generate innovative ideas!"
        alt="image of ai project planner project"
        deployLink="https://project-planner-ui.vercel.app/"
        ghLink="https://github.com/AI-Project-Planner/project-planner-ui"
      />
      <ProjectExample
        title="Celestial Cycle"
        tagline="Combining AI astrological insights with menstrual cycle tracking"
        technologies={["Next.JS", "OpenAI", "SupaBase", "1Password", "Tailwind CSS", "TypeScript", "Cypress"]}
        context="October 2023 | Group Project for WWCode Hackathon '23"
        img={celestial}
        summary="A seamless experience for users to input and track their menstrual flow, mood, cravings, and symptoms, alongside providing a glimpse of their daily horoscope and the current moon phase. "
        alt="image of celestial cycle project"
        deployLink="https://celestial-cycle.vercel.app/"
        ghLink="https://github.com/sakisandrac/style-stash"
      />
      <ProjectExample
        title="Style Stash"
        tagline="A Virtual Closet and Outfit Planning Application"
        technologies={["React", "Express.JS", "Node.JS", "PostgresSQL", "JavaScript", "HTML/CSS"]}
        context="August 2023 | Paired Passion Project"
        img={styleStash}
        summary="Effortlessly curate a virtual closet and seamlessly digitizing your wardrobe. Organize your favorite clothing pieces and accessories, making outfit planning a breeze. Mix and match items, experiment with styles, and plan your perfect looks for any occasion."
        alt="image of style stash project"
        deployLink="https://style-stash.vercel.app"
        ghLink="https://github.com/sakisandrac/style-stash"
      />
      <ProjectExample
        title="Dilettante's Muse"
        tagline="Discover Paintings from the Metropolitan Museum of Art"
        summary="Browse paintings from the Metropolitan Museam of Art and save your favorite paintings"
        technologies={["TypeScript", "React", "HTML/CSS"]}
        context="July 2023 | Group Project"
        img={dm}
        alt="image dilettante's muse project"
        deployLink="https://dilettantes-muse.vercel.app/"
        ghLink="https://github.com/sakisandrac/DilettantesMuse"
      />
      <ProjectExample
        title="OverLook Hotel"
        tagline="Booking Website"
        technologies={["JavaScript", "HTML/CSS", "Webpack", "TDD Mocha/Chai"]}
        context="June 2023 | Solo Project for Turing, Mod 2"
        img={overlookImg}
        alt="image of overlook hotel project"
        deployLink="https://sakisandrac.github.io/overlook-final-project"
        ghLink="https://github.com/sakisandrac/overlook-final-project"
      />
      {/* <ProjectExample
        title="Harry Potter SpellBook"
        tagline="Search Harry Potter Spells"
        technologies={["TypeScript", "React", "JavaScript", "HTML/CSS"]}
        context="June 2023 | Solo Practice Project"
        img={hpImg}
        alt="image of harry potter spellbook project"
        deployLink="https://sakic-hp-spellbox-react.vercel.app"
        ghLink="https://github.com/sakisandrac/hp-spellbox-ts"
      />
      <ProjectExample
        title="Poke-Dex Pokemon Encyclopedia"
        tagline="Search Harry Potter Spells"
        technologies={["React", "JavaScript", "HTML/CSS"]}
        context="July 2023 | Solo Practice Project"
        img={pokeImg}
        alt="image of poke dex project"
        deployLink="https://poke-dex-sakic.vercel.app/"
        ghLink="https://github.com/sakisandrac/poke-dex"
      /> */}
    </ div>
  )
}

export default Projects